// react
import React, { useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

// ant design
import { Modal } from "antd";

// contexts
import ApolloContext from "../../utils/apolloProvider";

// components
import Page from "../../components/Page";

// apollo & operations
import { QUERY_MESSAGE } from "../../operations/queries/messages";
import { UPDATE_MESSAGE } from "../../operations/mutations/messages";

// query params
const useQuery = () => new URLSearchParams(useLocation().search);

const MessageDelete = (props) => {
  const apollo = useContext(ApolloContext);
  const history = useNavigate();
  const { id } = useParams();
  const query = useQuery();
  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "/messages",
      breadcrumbName: "Messages",
    },
    {
      path: "",
      breadcrumbName: "Delete message",
    },
  ];

  const deleteMessage = async () => {
    try {
      const response = await apollo.client.query({
        query: QUERY_MESSAGE,
        variables: { id },
      });
      const message = { ...response.data.message };
      // @todo should only update hidden
      await apollo.client.mutate({
        mutation: UPDATE_MESSAGE,
        variables: {
          id: id,
          messageInput: { email: message.email, hidden: true },
        },
      });
      Modal.success({
        title: "Success",
        content: "The message has been hidden.",
        okText: "Return to listing",
        onOk: () => history.replace("/messages"),
      });
    } catch (e) {
      Modal.error({
        title: "An error has occurred",
        content: "The message has not been hidden.",
        okText: "Return to listing",
        onOk: () => history.replace("/messages"),
      });
    }
  };

  useEffect(() => {
    if (query.get("confirm") === "1") {
      deleteMessage();
    }
  }, []);

  return (
    <>
      <Page title="Delete message" breadcrumb={breadcrumb} />
    </>
  );
};

export default MessageDelete;
